// Compute URLs from hayagriva.appServer config
const hayagrivaAppServer = {
  baseURL: 'https://uat.optimastride.com',
  // baseURL: 'https://dev.optimastride.com',
  extension: 'api',
  version: 'v0',
  appId: '7293afc7-36c2-4971-a679-bb1f7c270d78',
  tenantuuid: '9427eb70-c41e-48f7-a1a1-e8c8362c840b',
  userToken: '403a4c09-e147-4242-9d4b-1cd1c50a253a'
};

import { ServingEnvironment } from '@optima-stride-ai/optima-app-framework';
import { Environment } from './environment.interface';
import { AppName } from '../enum/app-name';


export const environment: Environment = {
  appName: AppName.Hayagriva,
  displayName: 'Knowledge Base',
  subdomain: 'hayagriva',
  appId: hayagrivaAppServer.appId,
  appEnvironment: ServingEnvironment.uat,
  production: false,
  name: ServingEnvironment.uat,
  apiUrl:  `${hayagrivaAppServer.baseURL}/${hayagrivaAppServer.extension}/${hayagrivaAppServer.version}`,
  collaboraUrl: '',
  wopiUrl: hayagrivaAppServer.baseURL,
  whiteboardProxyUrl:  `${hayagrivaAppServer.baseURL}:5173/wopi`,

  // Feature flags
  collaboraEnabled: true,
  debugMode: true,

  platformApiUrl: `${hayagrivaAppServer.baseURL}/${hayagrivaAppServer.extension}/${hayagrivaAppServer.version}`,

  // Benzaiten configuration
  hayagriva: {
    appServer: {
      production: false,
      baseURL: hayagrivaAppServer.baseURL, // DO NOT PUT SLASH IN THE END
      extension: hayagrivaAppServer.extension, // DO NOT PUT ANY SLASHES
      version: hayagrivaAppServer.version, // DO NOT PUT ANY SLASHES,
      uploadFile: 'upload-file' // DO NOT PUT ANY SLASHES
    },
    headers: {
      tenantuuid: hayagrivaAppServer.tenantuuid,
      appid: hayagrivaAppServer.appId,
      userToken: hayagrivaAppServer.userToken
    }
  },

    whiteboard: {
    useYjsRealtime: true,
    yjsWsUrl: 'wss://yjs-api.optimastride.com'
  }
};

/**
 * hayagriva App Server URL helper
 */
export const hayagrivaAppServerURL = {
  baseURL: environment.hayagriva.appServer.baseURL,
  extension: environment.hayagriva.appServer.extension,
  version: environment.hayagriva.appServer.version
};

/**
 * hayagriva App Headers helper
 */
export const hayagrivaAppHeaders = {
  tenantuuid: environment.hayagriva.headers.tenantuuid,
  appid: environment.hayagriva.headers.appid,
  userToken: environment.hayagriva.headers.userToken
};
